import { Component, OnInit } from '@angular/core';
import {WarningComponent} from "../../../../../shared/components/warning/warning.component";
import {first, map} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {Message} from "../../../../../core/class/message";

@Component({
  selector: 'app-contract-digitzation-moha',
  templateUrl: './contract-digitzation-moha.component.html',
  styleUrls: ['./contract-digitzation-moha.component.scss']
})
export class ContractDigitizationMohaComponent implements OnInit {

  constructor(private dialog: MatDialog,public message: Message,) { }

  ngOnInit() {
  }
  canDeactivate() {
const mode = localStorage.getItem("digitalContractCancel");
const saveContract = localStorage.getItem("saveContract");
const urlCreate = location.href.includes('/create');
const urlUpdate = location.href.includes('/update');
if(mode && mode != "view" && (urlCreate || urlUpdate) && !saveContract){
  const dialogRe = this.dialog.open(WarningComponent, {
    width: "350px",
    data: this.message.getMessage("messages.confirm_change_data"),
  });
  return dialogRe.afterClosed().pipe(
    map((result) => {
      if (result) {
        return true;
      } else {
        return false;
      }
    }),
    first()
  );
}
else
{
  return true;
}
}


}
